import { ru } from './ru';

export const d = { ru };
